import { LinkNode } from '@lexical/link';
import { ListNode, ListItemNode } from '@lexical/list';
import { ParagraphNode, TextNode } from 'lexical';
import { TableCellNode } from '@lexical/table';

import type { DOMExportOutput, Klass, LexicalEditor, LexicalNode } from 'lexical';

import { CourseCatalogueNode } from './nodes';

export const mergeBoldStrongTags = (html: string): string => {
  let mergedHtml = html.replace(/<b><strong>/gi, '<strong>');
  mergedHtml = mergedHtml.replace(/<\/strong><\/b>/gi, '</strong>');
  return mergedHtml;
};

export const cleanUpTable = (html: string): string =>
  html.replace(/<div[^>]*>\s*(<table[\s\S]*?<\/table>)\s*<\/div>/gi, '$1');

export const removeStylesExportDOM = (editor: LexicalEditor, target: LexicalNode): DOMExportOutput => {
  const output = target.exportDOM(editor);
  if (output && output.element instanceof HTMLElement) {
    for (const el of [output.element, ...output.element.querySelectorAll('[style],[class],[dir="ltr"]')]) {
      el.removeAttribute('class');
      if (el.getAttribute('style')) {
        el.setAttribute('style', '');
        el.removeAttribute('style');
      }
      if (el.getAttribute('dir') === 'ltr') {
        el.removeAttribute('dir');
      }
    }
  }
  return output;
};

export const exportMap = new Map<Klass<LexicalNode>, (editor: LexicalEditor, target: LexicalNode) => DOMExportOutput>([
  [ParagraphNode, removeStylesExportDOM],
  [TextNode, removeStylesExportDOM],
  [ListNode, removeStylesExportDOM],
  [ListItemNode, removeStylesExportDOM],
  [TableCellNode, removeStylesExportDOM],
  [LinkNode, removeStylesExportDOM],
  [CourseCatalogueNode, removeStylesExportDOM],
]);

export const setScrollableContainers = (fn: (event: Event) => void) => {
  const scrollableContainers = document.querySelectorAll('*');
  scrollableContainers.forEach((container) => {
    if (container.scrollHeight > container.clientHeight) {
      container.addEventListener('scroll', fn);
    }
  });
};

export const removeScrollableContainers = (fn: (event: Event) => void) => {
  const scrollableContainers = document.querySelectorAll('*');
  scrollableContainers.forEach((container) => {
    if (container.scrollHeight > container.clientHeight) {
      container.removeEventListener('scroll', fn);
    }
  });
};
